import { Fragment } from 'react'
import s from './EmailFiles.scss'

const EmailFiles = ({ files, removeFile }) => {
  return (
    <ul className={s.files}>
      {files.map(file => (
        <Fragment key={file.s3Key || file.lastModified}>
          <li key={file.lastModified} className={s.fileItem}>
            <span className={s.file}>{file.name}</span>
            <span className={s.remove} onClick={() => removeFile(file)}>
              &times;
            </span>
          </li>
        </Fragment>
      ))}
    </ul>
  )
}

export default EmailFiles
